import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const INITIAL_STATE = {
  baseUrl: process.env.REACT_APP_BASE_URL,
  note: {
    isLoading: false,
    error: null,
  },
  apiStatus: {
    statusCode: null,
    statusText: null,
    data: {
      items: [],
    },
  },
};

export const ScheduleMessageSlice = createSlice({
  name: "scheduleMessage",
  initialState: INITIAL_STATE,
  reducers: {
    fetchScheduleMessageData: (state) => {
      state.note.isLoading = true;
    },
    fetchScheduleMessageSuccess: (state, action: PayloadAction<any>) => ({
      ...state,
      note: {
        ...state.note,
        error: null,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: action.payload?.statusCode,
        statusText: action.payload?.statusText,
        data: action.payload?.data,
      },
    }),
    fetchScheduleMessageFailure: (state, action: PayloadAction<any>) => ({
      ...state,
      note: {
        ...state.note,
        error: action.payload?.message,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: action.payload?.statusCode,
        statusText: action.payload?.statusText,
      },
    }),
    clearScheduleMessage: (state) => ({
      ...state,
      note: {
        ...state.note,
        error: null,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: null,
        statusText: null,
        data: {
          items: [],
        },
      },
    }),
  },
});

export const {
  fetchScheduleMessageData,
  fetchScheduleMessageFailure,
  fetchScheduleMessageSuccess,
  clearScheduleMessage,
} = ScheduleMessageSlice.actions;
export const ScheduleMessageReducer = ScheduleMessageSlice.reducer;
